import { MessageBar, MessageBarType, Separator } from "@fluentui/react";
import React from "react";
import { LabeledText, Shimmer, Stack, ensure } from "sprint-common-web";

import { isTrailerVersionType } from "../../../../common/types/TrailerContentVersion";
import { MediaBuzzVersion } from "./MediaBuzzVersion";

export interface BuzzVersionsListProps {
    versions: MediaBuzzVersion[];
    isLoading?: boolean;
}

export const BuzzVersionsList: React.FunctionComponent<BuzzVersionsListProps> = (props: BuzzVersionsListProps) => {
    return !props.isLoading ? (
        <div style={{ maxHeight: 220, overflowY: props.versions.length > 1 ? "auto" : "initial" }}>
            {props.versions.map(getVersionDetails)}
        </div>
    ) : (
        <Shimmer />
    );
};

const getVersion = (item: MediaBuzzVersion): string => {
    if (!item.brandings) {
        return `${item.versionType.name} - ${item.distributor}`;
    }

    return `${item.versionType.name} - ${item.distributor} - ${item.brandings}`;
};

const getVersionDetails = (item: MediaBuzzVersion, index: number, array: MediaBuzzVersion[]): JSX.Element => {
    if (isTrailerVersionType(item.versionType)) {
        return (
            <Stack key={`buzz-refrence-${index}`} styles={{ root: { height: "100%" } }}>
                <LabeledText testId="content-trailer-version" textTooltip label="Version" value={getVersion(item)} />
                {!isLastElement(index, array) && <Separator />}
            </Stack>
        );
    }

    if (!item.buzz) {
        return (
            <Stack key={`buzz-refrence-${index}`} styles={{ root: { height: "100%" } }}>
                <LabeledText testId="content-orphaned-version" textTooltip label="Version" value={getVersion(item)} />
                <MessageBar messageBarType={MessageBarType.warning} isMultiline={true}>
                    Version is orphaned
                </MessageBar>
                {!isLastElement(index, array) && <Separator />}
            </Stack>
        );
    }

    return (
        <Stack key={item.buzz.id} styles={{ root: { height: "100%" } }}>
            {renderBuzzInfo(item)}
            {!isLastElement(index, array) && <Separator />}
        </Stack>
    );
};

const isLastElement = (index: number, array: MediaBuzzVersion[]): boolean => {
    return index === array.length - 1;
};

const renderBuzzInfo = (item: MediaBuzzVersion) => {
    ensure(item.buzz);

    const baseInfo = (
        <>
            <LabeledText textTooltip label="Version" value={getVersion(item)} />
            <LabeledText textTooltip label="Buzz Id" value={item.buzz.id} />
        </>
    );

    if (!item.buzz?.name) {
        return baseInfo;
    }

    return (
        <>
            {baseInfo}
            <LabeledText label="Buzz name" value={item.buzz.name} />
            <LabeledText label="Buzz notes" value={item.buzz.notes} />
        </>
    );
};
